import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { LoaderService, Message, RestService } from '@stdoutsrl/design-kit';

@Component({
  selector: 'app-quiz-sessions',
  templateUrl: './quiz-sessions.component.html',
  styles: `
  .plus-add-block{
width: 40px;
padding-left: 20px;
padding-right: 20px;
opacity: 0;
transition-duration: 250ms;
  }
  .plus-add-block:hover{
    width: 100px;
    opacity: 1;
  }
  `,
  standalone: false
})
export class QuizSessionsComponent implements OnInit {
 
  constructor(private rest: RestService, private loader: LoaderService, private router: Router) { }

  quizList: any[] = []
  showModalDetail = false
  currentQuiz: any
  id = ''
  currentSession :any

  ngOnInit(): void {
    this.id = window.location.pathname.split('/')[2]
    this.getQuizSessions()
  }

  getQuizSessions(element?:any) {
    this.loader.on()
    let options = { filters: [{ v: this.id, s: "quiz_id", o: 1 },{ s: "started_at", o: 11 }],limit:999 ,orders:[{k:'started_at',v:'DESC'}] };
    this.rest.get(`/quiz-session?options=${JSON.stringify(options)}`).subscribe({
      next: (value: any) => {
        this.quizList = value.data
        if(element){
          element.style.opacity = '1'
        }
        this.loader.off(true)
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  addQuiz(t: any) {
    this.loader.on()
    this.rest.post('/quiz', { title: '', description: '', is_active: 0, requires_fiscal_code: 0 }).subscribe({
      next: (value: any) => {
        this.loader.off(true)
        this.router.navigate([t('routes.createQuiz.path').replace(':id', value.id)])
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  goBack(){
    window.history.back()
  }

  goToDetails(quiz: any, t: any) {
    // this.router.navigate([t('routes.createQuiz.path').replace(':id', quiz.id)])
    this.loader.on()
    this.rest.get(`/quiz-session/details/${quiz.id}`).subscribe({
      next: (value: any) => {
        this.currentSession = value
    this.showModalDetail = true
        this.loader.off(true)
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }



}
